<template>
    <DModal
        ref="assignCustomerModal"
        :show="showModal"
        :title="__('orders.title.assign_customer')"
        is-big
        is-confirm
        overflow-auto
        :is-awaiting-validation="true"
        @confirm="checkCustomerAssignment"
        @close="back"
    >
        <DCard padding>
            <div v-if="showConfirmDialog === false">
                <p><strong>{{ __('orders.confirm_assignment') }}</strong></p>
                <table class="table select-customer-table">
                    <thead>
                        <tr>
                            <th />
                            <th>{{ __('orders.order_customer') }}</th>
                            <th><DIcon name="arrow-right" /></th>
                            <th class="d-flex database-customers">
                                {{ __('orders.found_customers') }}
                                <DSelect
                                    class="select-margin"
                                    :options="databaseCustomerOptions"
                                    :value="selectedDatabaseCustomerOptionIndex"
                                    @update:value="setSelectedDatabaseCustomer($event)"
                                />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="selectedDatabaseCustomerData.orders_blocked">
                            <td />
                            <td />
                            <td />
                            <td class="orders-blocked-text">
                                {{ __('orders.blocked') }}
                            </td>
                        </tr>
                        <tr>
                            <td>{{ __('orders.customer_type') }}</td>
                            <td>{{ __(`customers.customers.customer_types.${orderCustomer.customer_type}`) }}</td>
                            <td>
                                <input
                                    v-model="doCopyCustomerType"
                                    type="checkbox"
                                >
                                <DIcon
                                    v-if="doCopyCustomerType"
                                    name="arrow-right"
                                    :size="13"
                                    class="arrow-icon-width"
                                />
                                <span
                                    v-else
                                    class="arrow-icon-width"
                                />
                            </td>
                            <td>
                                <span :class="compareCustomerData(orderCustomer.customer_type, selectedDatabaseCustomerData.customer_type) ? '' : 'different-customer-data'">
                                    {{ __(`customers.customers.customer_types.${selectedDatabaseCustomerData.customer_type}`) }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ __('orders.customer_no') }}</td>
                            <td>{{ orderCustomer.id }}</td>
                            <td />
                            <td>
                                <span :class="compareCustomerData(orderCustomer.id, selectedDatabaseCustomerData.id) ? '' : 'different-customer-data'">
                                    {{ selectedDatabaseCustomerData.id }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ __('orders.brand') }}</td>
                            <td v-if="orderCustomer.brand">
                                {{ orderCustomer.brand.name }}
                            </td>
                            <td>
                                <input
                                    v-model="doCopyBrand"
                                    type="checkbox"
                                >
                                <DIcon
                                    v-if="doCopyBrand"
                                    name="arrow-right"
                                    :size="13"
                                    class="arrow-icon-width"
                                />
                                <span
                                    v-else
                                    class="arrow-icon-width"
                                />
                            </td>
                            <td v-if="selectedDatabaseCustomerData.brand">
                                <span :class="compareCustomerData(orderCustomer.brand ? orderCustomer.brand.name : '', selectedDatabaseCustomerData.brand.name) ? '' : 'different-customer-data'">
                                    {{ selectedDatabaseCustomerData.brand.name }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ __('orders.salutation') }}</td>
                            <td>{{ orderCustomer.title }}</td>
                            <td>
                                <input
                                    v-model="doCopyCustomerTitle"
                                    type="checkbox"
                                >
                                <DIcon
                                    v-if="doCopyCustomerTitle"
                                    name="arrow-right"
                                    :size="13"
                                    class="arrow-icon-width"
                                />
                                <span
                                    v-else
                                    class="arrow-icon-width"
                                />
                            </td>
                            <td>
                                <span :class="compareCustomerData(orderCustomer.title, selectedDatabaseCustomerData.title) ? '' : 'different-customer-data'">
                                    {{ selectedDatabaseCustomerData.title }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ __('orders.customer_name') }}</td>
                            <td>{{ orderCustomer.firstname }} {{ orderCustomer.lastname }}</td>
                            <td>
                                <input
                                    v-model="doCopyCustomerName"
                                    type="checkbox"
                                >
                                <DIcon
                                    v-if="doCopyCustomerName"
                                    name="arrow-right"
                                    :size="13"
                                    class="arrow-icon-width"
                                />
                                <span
                                    v-else
                                    class="arrow-icon-width"
                                />
                            </td>
                            <td>
                                <span :class="compareCustomerData(orderCustomer.firstname, selectedDatabaseCustomerData.firstname) ? '' : 'different-customer-data'">
                                    {{ selectedDatabaseCustomerData.firstname }}
                                </span> <span :class="compareCustomerData(orderCustomer.lastname, selectedDatabaseCustomerData.lastname) ? '' : 'different-customer-data'">
                                    {{ selectedDatabaseCustomerData.lastname }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ __('orders.customer_company') }}</td>
                            <td>{{ orderCustomer.company }}</td>
                            <td>
                                <input
                                    v-model="doCopyCompany"
                                    type="checkbox"
                                >
                                <DIcon
                                    v-if="doCopyCompany"
                                    name="arrow-right"
                                    :size="13"
                                    class="arrow-icon-width"
                                />
                                <span
                                    v-else
                                    class="arrow-icon-width"
                                />
                            </td>
                            <td>
                                <span :class="compareCustomerData(orderCustomer.company, selectedDatabaseCustomerData.company) ? '' : 'different-customer-data'">
                                    {{ selectedDatabaseCustomerData.company }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ __('orders.email') }}</td>
                            <td>{{ orderCustomer.email }}</td>
                            <td />
                            <td>
                                <span :class="compareCustomerData(orderCustomer.email, selectedDatabaseCustomerData.email) ? '' : 'different-customer-data'">
                                    {{ selectedDatabaseCustomerData.email }}
                                </span>
                            </td>
                        </tr>
                        <tr v-if="isOneWebshopOrder && tenantSettings.ssn_business_id === true">
                            <td>{{ __('orders.business_id') }}</td>
                            <td>{{ orderCustomer.business_id }}</td>
                            <td />
                            <td>
                                <span :class="compareCustomerData(orderCustomer.business_id, selectedDatabaseCustomerData.business_id) ? '' : 'different-customer-data'">
                                    {{ selectedDatabaseCustomerData.business_id }}
                                </span>
                            </td>
                        </tr>
                        <tr v-if="isOneWebshopOrder && tenantSettings.ssn_business_id === true">
                            <td>{{ __('orders.ssn') }}</td>
                            <td>{{ orderCustomer.ssn }}</td>
                            <td />
                            <td>
                                <span :class="compareCustomerData(orderCustomer.ssn, selectedDatabaseCustomerData.ssn) ? '' : 'different-customer-data'">
                                    {{ selectedDatabaseCustomerData.ssn }}
                                </span>
                            </td>
                        </tr>
                        <tr v-if="isOneWebshopOrder">
                            <td>{{ __('orders.invoice_delivery_type') }}</td>
                            <td>{{ orderCustomer.invoice_delivery_type.value }}</td>
                            <td>
                                <input
                                    v-model="doCopyInvoiceDeliveryType"
                                    type="checkbox"
                                >
                                <DIcon
                                    v-if="doCopyInvoiceDeliveryType"
                                    name="arrow-right"
                                    :size="13"
                                    class="arrow-icon-width"
                                />
                                <span
                                    v-else
                                    class="arrow-icon-width"
                                />
                            </td>
                            <td>
                                <span :class="compareCustomerData(orderCustomer.invoice_delivery_type.value, selectedDatabaseCustomerData.invoice_delivery_type.value) ? '' : 'different-customer-data'">
                                    {{ selectedDatabaseCustomerData.invoice_delivery_type.value }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ __('orders.customer_address') }}</td>
                            <td>
                                {{ orderCustomer.address1 }}<br>
                                {{ orderCustomer.address2 }}<br>
                                {{ orderCustomer.postal_code }} {{ orderCustomer.city }}<br>
                                {{ orderCustomer.country_code }}
                            </td>
                            <td>
                                <input
                                    v-model="doCopyAdress"
                                    type="checkbox"
                                >
                                <DIcon
                                    v-if="doCopyAdress"
                                    name="arrow-right"
                                    :size="13"
                                    class="arrow-icon-width"
                                />
                                <span
                                    v-else
                                    class="arrow-icon-width"
                                />
                            </td>
                            <td>
                                <span :class="compareCustomerData(orderCustomer.address1, selectedDatabaseCustomerData.address1) ? '' : 'different-customer-data'">
                                    {{ selectedDatabaseCustomerData.address1 }}
                                </span><br>
                                <span :class="compareCustomerData(orderCustomer.address2, selectedDatabaseCustomerData.address2) ? '' : 'different-customer-data'">
                                    {{ selectedDatabaseCustomerData.address2 }}
                                </span><br>
                                <span :class="compareCustomerData(orderCustomer.postal_code, selectedDatabaseCustomerData.postal_code) ? '' : 'different-customer-data'">
                                    {{ selectedDatabaseCustomerData.postal_code }}
                                </span> <span :class="compareCustomerData(orderCustomer.city, selectedDatabaseCustomerData.city) ? '' : 'different-customer-data'">
                                    {{ selectedDatabaseCustomerData.city }}
                                </span><br>
                                <span :class="compareCustomerData(orderCustomer.country_code, selectedDatabaseCustomerData.country_code) ? '' : 'different-customer-data'">
                                    {{ selectedDatabaseCustomerData.country_code }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ __('orders.birthday') }}</td>
                            <td>{{ orderCustomer.birthday }}</td>
                            <td>
                                <input
                                    v-model="doCopyBirthday"
                                    type="checkbox"
                                >
                                <DIcon
                                    v-if="doCopyBirthday"
                                    name="arrow-right"
                                    :size="13"
                                    class="arrow-icon-width"
                                />
                                <span
                                    v-else
                                    class="arrow-icon-width"
                                />
                            </td>
                            <td>
                                <span :class="compareCustomerData(orderCustomer.birthday, selectedDatabaseCustomerData.birthday) ? '' : 'different-customer-data'">
                                    {{ selectedDatabaseCustomerData.birthday }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ __('orders.phone') }}</td>
                            <td>{{ orderCustomer.phone }}</td>
                            <td>
                                <input
                                    v-model="doCopyPhone"
                                    type="checkbox"
                                >
                                <DIcon
                                    v-if="doCopyPhone"
                                    name="arrow-right"
                                    :size="13"
                                    class="arrow-icon-width"
                                />
                                <span
                                    v-else
                                    class="arrow-icon-width"
                                />
                            </td>
                            <td>
                                <span :class="compareCustomerData(orderCustomer.phone, selectedDatabaseCustomerData.phone) ? '' : 'different-customer-data'">
                                    {{ selectedDatabaseCustomerData.phone }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ __('orders.payment_method') }}</td>
                            <td>{{ selectOrderPaymentMethod }}</td>
                            <td>
                                <input
                                    v-model="doCopyPaymentMethod"
                                    type="checkbox"
                                >
                                <DIcon
                                    v-if="doCopyPaymentMethod"
                                    name="arrow-right"
                                    :size="13"
                                    class="arrow-icon-width"
                                />
                                <span
                                    v-else
                                    class="arrow-icon-width"
                                />
                            </td>
                            <td>
                                <span :class="compareCustomerData(selectOrderPaymentMethod, selectedDatabaseCustomerData.payment_method) ? '' : 'different-customer-data'">
                                    {{ selectedDatabaseCustomerData.payment_method }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ __('orders.iban') }}</td>
                            <td>{{ selectedOrderIban }}</td>
                            <td>
                                <input
                                    v-model="doCopyPaymentIban"
                                    type="checkbox"
                                >
                                <DIcon
                                    v-if="doCopyPaymentIban"
                                    name="arrow-right"
                                    :size="13"
                                    class="arrow-icon-width"
                                />
                                <span
                                    v-else
                                    class="arrow-icon-width"
                                />
                            </td>
                            <td>
                                <span :class="compareCustomerData(selectedOrderIban, databaseCustomerIban) ? '' : 'different-customer-data'">
                                    {{ databaseCustomerIban }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ __('orders.bic') }}</td>
                            <td>{{ selectedOrderBic }}</td>
                            <td>
                                <input
                                    v-model="doCopyPaymentBic"
                                    type="checkbox"
                                >
                                <DIcon
                                    v-if="doCopyPaymentBic"
                                    name="arrow-right"
                                    :size="13"
                                    class="arrow-icon-width"
                                />
                                <span
                                    v-else
                                    class="arrow-icon-width"
                                />
                            </td>
                            <td>
                                <span :class="compareCustomerData(selectedOrderBic, databaseCustomerBic) ? '' : 'different-customer-data'">
                                    {{ databaseCustomerBic }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ __('orders.account_owner') }}</td>
                            <td>{{ selectedOrderAccountOwner }}</td>
                            <td>
                                <input
                                    v-model="doCopyAccountOwner"
                                    type="checkbox"
                                >
                                <DIcon
                                    v-if="doCopyAccountOwner"
                                    name="arrow-right"
                                    :size="13"
                                    class="arrow-icon-width"
                                />
                                <span
                                    v-else
                                    class="arrow-icon-width"
                                />
                            </td>
                            <td>
                                <span :class="compareCustomerData(selectedOrderAccountOwner, databaseCustomerAccountOwner) ? '' : 'different-customer-data'">
                                    {{ databaseCustomerAccountOwner }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-else>
                <p>{{ __('orders.assign_customer_confirm') }}</p>
                <table class="table select-customer-table">
                    <tbody>
                        <tr>
                            <td>{{ __('orders.customer_type') }}</td>
                            <td>{{ __(`customers.customers.customer_types.${doCopyCustomerType ? orderCustomer.customer_type : selectedDatabaseCustomerData.customer_type}`) }}</td>
                        </tr>
                        <tr>
                            <td>{{ __('orders.customer_no') }}</td>
                            <td>{{ selectedDatabaseCustomerData.id }}</td>
                        </tr>
                        <tr>
                            <td>{{ __('orders.brand') }}</td>
                            <td v-if="orderCustomer.brand">
                                {{ doCopyBrand ? orderCustomer.brand.id : selectedDatabaseCustomerData.brand_id }}
                            </td>
                        </tr>
                        <tr>
                            <td>{{ __('orders.salutation') }}</td>
                            <td>{{ doCopyCustomerTitle ? orderCustomer.title : selectedDatabaseCustomerData.title }}</td>
                        </tr>
                        <tr>
                            <td>{{ __('orders.customer_name') }}</td>
                            <td>{{ doCopyCustomerName ? orderCustomer.firstname : selectedDatabaseCustomerData.firstname }} {{ doCopyCustomerName ? orderCustomer.lastname : selectedDatabaseCustomerData.lastname }}</td>
                        </tr>
                        <tr>
                            <td>{{ __('orders.customer_company') }}</td>
                            <td>{{ doCopyCompany ? orderCustomer.company : selectedDatabaseCustomerData.company }}</td>
                        </tr>
                        <tr>
                            <td>{{ __('orders.email') }}</td>
                            <td>{{ selectedDatabaseCustomerData.email }}</td>
                        </tr>
                        <tr v-if="isOneWebshopOrder && tenantSettings.ssn_business_id === true">
                            <td>{{ __('orders.business_id') }}</td>
                            <td>{{ selectedDatabaseCustomerData.business_id }}</td>
                        </tr>
                        <tr v-if="isOneWebshopOrder && tenantSettings.ssn_business_id === true">
                            <td>{{ __('orders.ssn') }}</td>
                            <td>{{ selectedDatabaseCustomerData.ssn }}</td>
                        </tr>
                        <tr v-if="isOneWebshopOrder">
                            <td>{{ __('orders.invoice_delivery_type') }}</td>
                            <td>{{ doCopyInvoiceDeliveryType ? orderCustomer.invoice_delivery_type.value : selectedDatabaseCustomerData.invoice_delivery_type.value }}</td>
                        </tr>
                        <tr>
                            <td>{{ __('orders.customer_address') }}</td>
                            <td>
                                {{ doCopyAdress ? orderCustomer.address1 : selectedDatabaseCustomerData.address1 }}<br>
                                {{ doCopyAdress ? orderCustomer.address2 : selectedDatabaseCustomerData.address2 }}<br>
                                {{ doCopyAdress ? orderCustomer.postal_code : selectedDatabaseCustomerData.postal_code }} {{ doCopyAdress ? orderCustomer.city : selectedDatabaseCustomerData.city }}<br>
                                {{ doCopyAdress ? orderCustomer.country_code : selectedDatabaseCustomerData.country_code }}<br>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ __('orders.birthday') }}</td>
                            <td>{{ doCopyBirthday ? orderCustomer.birthday : selectedDatabaseCustomerData.birthday }}</td>
                        </tr>
                        <tr>
                            <td>{{ __('orders.phone') }}</td>
                            <td>{{ doCopyPhone ? orderCustomer.phone : selectedDatabaseCustomerData.phone }}</td>
                        </tr>
                        <tr>
                            <td>{{ __('orders.payment_method') }}</td>
                            <td>{{ doCopyPaymentMethod ? selectOrderPaymentMethod : selectedDatabaseCustomerData.payment_method }}</td>
                        </tr>
                        <tr>
                            <td>{{ __('orders.iban') }}</td>
                            <td>{{ selectedOrderIban }}</td>
                        </tr>
                        <tr>
                            <td>{{ __('orders.bic') }}</td>
                            <td>{{ selectedOrderBic }}</td>
                        </tr>
                        <tr>
                            <td>{{ __('orders.account_owner') }}</td>
                            <td>{{ selectedOrderAccountOwner }}</td>+
                        </tr>
                    </tbody>
                </table>
            </div>
        </DCard>
    </DModal>
</template>

<script>
import { customerBankDetails } from '~@/Composables/sepaMandate'

export default {
    name: 'CustomerAssignDialogModal',
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        selectedItem: {
            type: Object,
            default: () => { return {} }
        },
        selectedDatabaseCustomer: {
            type: Object,
            default: () => { return {} }
        },
        orderCustomer: {
            type: Object,
            default: () => { return {} }
        },
        databaseCustomers: {
            type: Array,
            default: () => { return [] }
        },
        isOneWebshopOrder: {
            type: Boolean,
            default: false
        }
    },
    emits: ['confirm-modal', 'close-modal'],
    data () {
        return {
            showConfirmDialog: false,
            doCopyCustomerType: false,
            doCopyBrand: false,
            doCopyCustomerTitle: false,
            doCopyCustomerName: false,
            doCopyCompany: false,
            doCopyAdress: false,
            doCopyInvoiceDeliveryType: false,
            doCopyBirthday: false,
            doCopyPhone: false,
            doCopyPaymentMethod: false,
            doCopyPaymentIban: false,
            doCopyPaymentBic: false,
            doCopyAccountOwner: false,
            doCopyOrderBlocked: false,
            doCopyOrderBlockedReason: false,
            selectedDatabaseCustomerData: this.selectedDatabaseCustomer,
            selectedItemData: this.selectedItem,
            selectedDatabaseCustomerOptionIndex: 0
        }
    },
    computed: {
        databaseCustomerOptions () {
            return this.databaseCustomers.map((customer, index) => {
                const customerName = customer.company ? customer.company : `${customer.firstname} ${customer.lastname}`

                return {
                    label: `${customerName} (${customer.id})`,
                    value: index
                }
            })
        },
        selectOrderPaymentMethod () {
            return this.selectedItemData.payment?.type ?? this.selectedItemData.paymentMethod ?? ''
        },
        selectedOrderIban () {
            return this.selectedItemData.payment?.iban ?? ''
        },
        databaseCustomerIban () {
            return this.selectedDatabaseCustomerData.bankDetails?.iban ?? ''
        },
        selectedOrderBic () {
            return this.selectedItemData.payment?.bic ?? ''
        },
        databaseCustomerBic () {
            return this.selectedDatabaseCustomerData.bankDetails?.bic ?? ''
        },
        selectedOrderAccountOwner () {
            return this.selectedItemData.payment?.holder ?? ''
        },
        databaseCustomerAccountOwner () {
            return this.selectedDatabaseCustomerData.bankDetails?.accountOwner ?? ''
        },
        tenantSettings () {
            return this.$page.props.tenantSettings
        }
    },
    methods: {
        setSelectedDatabaseCustomer (event) {
            this.selectedDatabaseCustomerOptionIndex = event
            this.selectedDatabaseCustomerData = this.databaseCustomers[event]
            this.selectedDatabaseCustomerData.bankDetails = this.getCustomerBankDetails(this.selectedDatabaseCustomerData)
        },
        compareCustomerData (currentValue, newValue) {
            return currentValue === newValue
        },
        getCustomerBankDetails (customer) {
            return customerBankDetails(customer)
        },
        checkCustomerAssignment () {
            if (
                (
                    this.doCopyCustomerType ||
                    this.doCopyBrand ||
                    this.doCopyCustomerTitle ||
                    this.doCopyCustomerName ||
                    this.doCopyCompany ||
                    this.doCopyAdress ||
                    this.doCopyBirthday ||
                    this.doCopyPhone ||
                    this.doCopyPaymentMethod ||
                    this.doCopyPaymentIban ||
                    this.doCopyPaymentBic ||
                    this.doCopyInvoiceDeliveryType ||
                    this.doCopyAccountOwner
                ) && this.showConfirmDialog === false
            ) {
                this.showConfirmDialog = true
            } else {
                const finalCustomer = this.selectedItem.customer

                finalCustomer.customer_type = this.doCopyCustomerType ? this.orderCustomer.customer_type : this.selectedDatabaseCustomerData.customer_type
                finalCustomer.brand_id = this.doCopyBrand ? this.orderCustomer.brand.id : this.selectedDatabaseCustomerData.brand_id
                finalCustomer.title = this.doCopyCustomerTitle ? this.orderCustomer.title : this.selectedDatabaseCustomerData.title
                finalCustomer.firstname = this.doCopyCustomerName ? this.orderCustomer.firstname : this.selectedDatabaseCustomerData.firstname
                finalCustomer.lastname = this.doCopyCustomerName ? this.orderCustomer.lastname : this.selectedDatabaseCustomerData.lastname
                finalCustomer.company = this.doCopyCompany ? this.orderCustomer.company : this.selectedDatabaseCustomerData.company
                finalCustomer.address1 = this.doCopyAdress ? this.orderCustomer.address1 : this.selectedDatabaseCustomerData.address1
                finalCustomer.address2 = this.doCopyAdress ? this.orderCustomer.address2 : this.selectedDatabaseCustomerData.address2
                finalCustomer.postal_code = this.doCopyAdress ? this.orderCustomer.postal_code : this.selectedDatabaseCustomerData.postal_code
                finalCustomer.city = this.doCopyAdress ? this.orderCustomer.city : this.selectedDatabaseCustomerData.city
                finalCustomer.country_code = this.doCopyAdress ? this.orderCustomer.country_code : this.selectedDatabaseCustomerData.country_code
                finalCustomer.birthday = this.doCopyBirthday ? this.orderCustomer.birthday : this.selectedDatabaseCustomerData.birthday
                finalCustomer.phone = this.doCopyPhone ? this.orderCustomer.phone : this.selectedDatabaseCustomerData.phone
                finalCustomer.payment_method = this.doCopyPaymentMethod ? this.selectOrderPaymentMethod : this.selectedDatabaseCustomerData.payment_method
                finalCustomer.payment_iban = this.doCopyPaymentIban ? this.selectedOrderIban : this.databaseCustomerIban
                finalCustomer.payment_bic = this.doCopyPaymentBic ? this.selectedOrderBic : this.databaseCustomerBic
                finalCustomer.account_owner = this.doCopyAccountOwner ? this.selectedOrderAccountOwner : this.databaseCustomerAccountOwner
                finalCustomer.invoice_delivery_type_id = this.doCopyInvoiceDeliveryType ? this.orderCustomer.invoice_delivery_type?.id ?? null : this.selectedDatabaseCustomerData.invoice_delivery_type?.id ?? null
                finalCustomer.electronic_invoice_id = this.doCopyInvoiceDeliveryType ? this.orderCustomer.electronic_invoice_id ?? null : this.selectedDatabaseCustomerData.electronic_invoice_id ?? null
                finalCustomer.electronic_invoicing_type = this.doCopyInvoiceDeliveryType ? this.orderCustomer.electronic_invoicing_type ?? null : this.selectedDatabaseCustomerData.electronic_invoicing_type ?? null

                this.$emit('confirm-modal', {
                    finalCustomer: finalCustomer,
                    order: this.selectedItem,
                    customerId: this.selectedDatabaseCustomerData.id
                })
            }
        },
        back () {
            if (this.showConfirmDialog === true) {
                this.showConfirmDialog = false
                this.$refs.assignCustomerModal.open()
            } else {
                this.$emit('close-modal')
            }
        }
    }
}
</script>

<style scoped>
.arrow-icon-width {
    display: inline-block;
    min-width: 13px;
    min-height: 13px;
}
.different-customer-data {
    background-color: #ffff66;
}
</style>
